






















import Vue from 'vue'
import Avater from '@/components/atoms/Avater.vue'
import IconButton from '@/components/molecules/IconButton.vue'

export default Vue.extend({
  name: 'StatusSection',
  components: {
    Avater,
    IconButton
  },
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    point: {
      type: Number,
      required: true,
      default: 0
    },
    cover: {
      type: String,
      required: true
    },
    portrait: {
      type: String,
      required: true
    },
    isConnected: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onShareClick: function() {
      if (this.isConnected) {
        window.open(
          'https://twitter.com/intent/tweet?text=一番搾り1年分が抽選で当たる！浦和レッズ公式ビール一番搾りポイントキャンペーン&hashtags=浦和レッズ公式ビール一番搾り&url=https://ichiban.themint.jp',
          '_blank'
        )
      } else {
        window.open('/about/share')
      }
    },
    onCheckInClick: function() {
      this.$router.push('/checkin')
    },
    onEatMapClick: function() {
      window.open('https://drive.google.com/a/themint.jp/open?id=18bXwtkWb4FvcLq1UnhA9t1yDcSdc2dQ6&usp=sharing', '_blank')
    }
  }
})
